/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_FaqInputs */

const he_footer_faq = /** @type {(inputs: Footer_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שאלות נפוצות`)
};

const en_footer_faq = /** @type {(inputs: Footer_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

/**
* | output |
* | --- |
* | "FAQ" |
*
* @param {Footer_FaqInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_faq = /** @type {((inputs?: Footer_FaqInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_FaqInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_footer_faq(inputs)
	return en_footer_faq(inputs)
});